import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const BackOnAirImportFileRequest = (userId, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}BackOnAir/ImportFile`,
		params: { userId },
		data: formData,
		hasLoading: true,
	});
};

export const BackOnAirGetLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BackOnAir/GetLastUpdate`,
	hasLoading: true,
});

export const BackOnAirGenerateResultRequest = (userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}BackOnAir/GenerateResult`,
	params: { userId },
	hasLoading: true,
});

export const HelixGetStatusRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BackOnAir/HelixGetStatus`,
	hasLoading: false,
});

export const HelixFetchDataRequest = (userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}BackOnAir/HelixFetchData`,
	params: { userId },
	hasLoading: true,
});

export const HelixExportResultRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BackOnAir/HelixExportResult`,
	params: { userId },
	hasLoading: true,
});

export const HelixGetQueueRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}BackOnAir/HelixGetQueue`,
	hasLoading: false,
});